import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
// components
import Iconify from 'src/components/Iconify';
import CanaisConfig from './CanaisConfig';
import { Button } from 'src/@/components/ui/button';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
// hooks
import useAuth from 'src/hooks/useAuth';
// actions
import v2_actionListUsersByClient from 'src/actions/v2/usuarios/v2_actionListUsersByClient';
import v2_actionListSectorsByClient from 'src/actions/v2/cliente/v2_actionListSectorsByClient';
import v2_actionDetalhesCanal from 'src/actions/v2/cliente/canais/v2_actionDetalhesCanal';
import v2_actionEditarCanal from 'src/actions/v2/cliente/canais/v2_actionEditarCanal';

// ----------------------------------------------------------------------

export default function CanaisDetails() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { user, cliente } = useAuth();
    const location = useLocation();

    const [isEdit, setIsEdit] = useState(true);
    const [listUsers, setListUsers] = useState([]);
    const [listSectors, setListSectors] = useState([]);
    const [loading, setLoading] = useState(false);

    // Extrai o parâmetro de consulta "channel" da string de busca (search) da URL
    const params = new URLSearchParams(location.search);
    const channel = params.get('channelId');
    const isNew = params.get('new');

    const [canal, setCanal] = useState({
        nome: '',
        status: true,
        platform: 'whatsapp',
        date: new Date(),
        principal: true,
        sessao: '',
        pod: '',
        descontinuado: false,
        webhook_type: '',
    });

    const [configAi, setConfigAi] = useState({
        prompt: '',
        provider: '',
        openai: { apiKey: '', organization: '', model: '' },
        gemini: { apiKey: '', model: '' },
        modules: {
            aiAnalysisChat: {
                customPrompts: false,
                prompt_alerts: '',
                prompt_predictive: '',
                prompt_resume: '',
                prompt_sentiment: '',
                prompt_subject: '',
                prompt_suggestion: '',
            },
        },
        allowsInChat: [],
        messages: {
            msgAfterTargeting: '',
            msgBreakFiles: 'Não é permitido enviar arquivos',
            msgBreakAudios: 'Não é permitido enviar audios',
            msgImages: 'No momento nao consigo ver sua imagem, por fvor envie um audio ou mensgem de texto',
            messageCallback: 'Nao consegue entender sua mensagem, pode enviar uma mensagem de texto?',
        },
    });

    const [config, setConfig] = useState({
        token: '',
        usuario: '',
        sessao: '',
        dialogflow: { privateKey: '', status: true, projectId: '', clientEmail: '' },
        direcionamento_direto: {
            direcionado_para: '',
            direciona_setor: [],
            direciona_usuario: [],
            statusRoom: '',
            mensagem_apos_cadastro: '',
        },
        aplicativo: { status: true },
        meta: { whatsappBusinness: { fromNumberId: '', accessToken: '', wabaId: '' } },
        incomingcall: { status: true, message: '' },
        flowbuilder: { flowId: '' },
        chatflow: { chatflow_id: '' },
        ai: configAi,
        laisGo: { status: false },
        departamentConfig: { allocate: { status: false, type: 'round_robin' }, wallet: { status: false } },
    });

    let makeChannel = { ...canal, config: config };

    async function getDetailsChannel() {
        try {
            const response = await v2_actionDetalhesCanal(channel);
            const responseChannel = response.data.data;
            if (responseChannel) {
                setCanal({
                    ...canal,
                    _id: responseChannel._id,
                    nome: responseChannel.nome,
                    platform: responseChannel.platform,
                    webhook_type: responseChannel.webhook_type,
                    cliente_id: responseChannel.cliente_id,
                });

                // Mescla a configuração do servidor com a estrutura inicial
                const serverConfig = responseChannel.config || {};

                // Converter feedbackTemplateVariaveis de objeto para array se necessário
                let feedbackTemplateVariaveis = serverConfig.generalConfig?.feedbackTemplateVariaveis;
                if (feedbackTemplateVariaveis && !Array.isArray(feedbackTemplateVariaveis)) {
                    // Se for objeto, converter para array simples de strings
                    const numerosOrdenados = Object.keys(feedbackTemplateVariaveis).sort((a, b) => parseInt(a) - parseInt(b));
                    const maxNumero =
                        numerosOrdenados.length > 0 ? parseInt(numerosOrdenados[numerosOrdenados.length - 1]) : 0;
                    const arrayVariaveis = [];
                    for (let i = 1; i <= maxNumero; i++) {
                        arrayVariaveis.push(feedbackTemplateVariaveis[String(i)] || '');
                    }
                    feedbackTemplateVariaveis = arrayVariaveis;
                } else if (Array.isArray(feedbackTemplateVariaveis)) {
                    // Se já for array de objetos, converter para array simples
                    if (
                        feedbackTemplateVariaveis.length > 0 &&
                        typeof feedbackTemplateVariaveis[0] === 'object' &&
                        feedbackTemplateVariaveis[0].numero
                    ) {
                        const maxNumero = Math.max(...feedbackTemplateVariaveis.map((v) => parseInt(v.numero)));
                        const arrayVariaveis = [];
                        for (let i = 1; i <= maxNumero; i++) {
                            const variavel = feedbackTemplateVariaveis.find((v) => v.numero === String(i));
                            arrayVariaveis.push(variavel?.valor || '');
                        }
                        feedbackTemplateVariaveis = arrayVariaveis;
                    }
                } else if (!feedbackTemplateVariaveis) {
                    feedbackTemplateVariaveis = [];
                }

                setConfig({
                    ...config,
                    ...serverConfig,
                    generalConfig: {
                        ...(serverConfig.generalConfig || {}),
                        feedbackTemplateVariaveis: feedbackTemplateVariaveis,
                    },
                    ai: {
                        ...config.ai,
                        ...(serverConfig.ai || {}),
                        modules: {
                            ...(config.ai?.modules || {}),
                            ...(serverConfig.ai?.modules || {}),
                            aiAnalysisChat: {
                                customPrompts: false,
                                prompt_alerts: '',
                                prompt_predictive: '',
                                prompt_resume: '',
                                prompt_sentiment: '',
                                prompt_subject: '',
                                prompt_suggestion: '',
                                ...(serverConfig.ai?.modules?.aiAnalysisChat || {}),
                            },
                        },
                    },
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function createChannel() {
        try {
            let data = { action: 'editar_canal_front', scope: makeChannel };
            setLoading(true);
            await v2_actionEditarCanal(channel, data);
            enqueueSnackbar('Canal salvo com sucesso', { variant: 'success' });
            setLoading(false);
        } catch (error) {
            setLoading(false);
            enqueueSnackbar('Erro ao salvar canal', { variant: 'error' });
            console.log(error);
        }
    }

    async function getListUsers() {
        try {
            const response = await v2_actionListUsersByClient(user.clienteId);
            setListUsers(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }

    async function getListSectors() {
        try {
            const response = await v2_actionListSectorsByClient(user.clienteId);
            setListSectors(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }

    async function handleOnChangeChannel(e, newValue) {
        const { name, value } = e.target;
        switch (name) {
            case 'channelName':
                setCanal({ ...canal, nome: value });
                break;
            case 'statusRoomDirectTarget':
                setConfig({ ...config, direcionamento_direto: { ...config.direcionamento_direto, statusRoom: value } });
                break;
            case 'channelType':
                setCanal({ ...canal, platform: value });
                break;
            case 'dialogflowPrivateKey':
                setConfig({ ...config, dialogflow: { ...config.dialogflow, privateKey: value } });
                break;
            case 'dialogflowProjectId':
                setConfig({ ...config, dialogflow: { ...config.dialogflow, projectId: value } });
                break;
            case 'dialogflowClientEmail':
                setConfig({ ...config, dialogflow: { ...config.dialogflow, clientEmail: value } });
                break;
            case 'providerAi':
                setConfig({ ...config, ai: { ...(config.ai || {}), provider: value } });
                break;
            case 'openaiApiKey':
                setConfig({ ...config, ai: { ...(config.ai || {}), openai: { ...(config.ai?.openai || {}), apiKey: value } } });
                break;
            case 'openaiOrganization':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), openai: { ...(config.ai?.openai || {}), organization: value } },
                });
                break;
            case 'geminiApiKey':
                setConfig({ ...config, ai: { ...(config.ai || {}), gemini: { ...(config.ai?.gemini || {}), apiKey: value } } });
                break;
            case 'modelGemini':
                setConfig({ ...config, ai: { ...(config.ai || {}), gemini: { ...(config.ai?.gemini || {}), model: value } } });
                break;
            case 'messageCallback':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), messages: { ...(config.ai?.messages || {}), messageCallback: value } },
                });
                break;
            case 'modelOpenai':
                setConfig({ ...config, ai: { ...(config.ai || {}), openai: { ...(config.ai?.openai || {}), model: value } } });
                break;
            case 'apiOpenai':
                setConfig({ ...config, ai: { ...(config.ai || {}), openai: { ...(config.ai?.openai || {}), apiKey: value } } });
                break;
            case 'apiKeyGemini':
                setConfig({ ...config, ai: { ...(config.ai || {}), gemini: { ...(config.ai?.gemini || {}), apiKey: value } } });
                break;
            case 'apiKeyOpenai':
                setConfig({ ...config, ai: { ...(config.ai || {}), openai: { ...(config.ai?.openai || {}), apiKey: value } } });
                break;
            case 'organizationOpenai':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), openai: { ...(config.ai?.openai || {}), organization: value } },
                });
                break;
            case 'msgAfterTargeting':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), messages: { ...(config.ai?.messages || {}), msgAfterTargeting: value } },
                });
                break;
            case 'msgBreakFiles':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), messages: { ...(config.ai?.messages || {}), msgBreakFiles: value } },
                });
                break;
            case 'msgBreakAudios':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), messages: { ...(config.ai?.messages || {}), msgBreakAudios: value } },
                });
                break;
            case 'msgBreakImages':
                setConfig({
                    ...config,
                    ai: { ...(config.ai || {}), messages: { ...(config.ai?.messages || {}), msgImages: value } },
                });
                break;
            case 'prompt':
                setConfig({ ...config, ai: { ...(config.ai || {}), prompt: value } });
                break;
            case 'directTargetMessage':
                setConfig({
                    ...config,
                    direcionamento_direto: { ...config.direcionamento_direto, mensagem_apos_cadastro: value },
                });
                break;
            case 'laisai_v2.ai_agent_id':
                setConfig({ ...config, laisai_v2: { ...config.laisai_v2, ai_agent_id: value } });
                break;
            case 'generalConfig.msgs.finish':
                setConfig({
                    ...config,
                    generalConfig: { ...(config.generalConfig || {}), msgs: { ...(config.generalConfig?.msgs || {}), finish: value } },
                });
                break;
            case 'generalConfig.msgs.feedback':
                setConfig({
                    ...config,
                    generalConfig: {
                        ...(config.generalConfig || {}),
                        msgs: { ...(config.generalConfig?.msgs || {}), feedback: value },
                    },
                });
                break;
            case 'generalConfig.msgs.welcome':
                setConfig({
                    ...config,
                    generalConfig: {
                        ...(config.generalConfig || {}),
                        msgs: { ...(config.generalConfig?.msgs || {}), welcome: value },
                    },
                });
                break;
            case 'generalConfig.msgs.transfer':
                setConfig({
                    ...config,
                    generalConfig: {
                        ...(config.generalConfig || {}),
                        msgs: { ...(config.generalConfig?.msgs || {}), transfer: value },
                    },
                });
                break;
            case 'generalConfig.msgs.afterTarget':
                setConfig({
                    ...config,
                    generalConfig: {
                        ...(config.generalConfig || {}),
                        msgs: { ...(config.generalConfig?.msgs || {}), afterTarget: value },
                    },
                });
                break;
            case 'generalConfig.msgTransfer':
                setConfig({ ...config, generalConfig: { ...(config.generalConfig || {}), msgTransfer: value } });
                break;
            case 'generalConfig.msgFinish':
                setConfig({ ...config, generalConfig: { ...(config.generalConfig || {}), msgFinish: value } });
                break;
            case 'generalConfig.feedback':
                setConfig({ ...config, generalConfig: { ...(config.generalConfig || {}), feedback: value } });
                break;
            case 'generalConfig.feedbackTemplate':
                console.log('🟢 CanaisDetails: Atualizando feedbackTemplate', value);
                setConfig((prevConfig) => {
                    const newConfig = {
                        ...prevConfig,
                        generalConfig: { ...(prevConfig.generalConfig || {}), feedbackTemplate: value },
                    };
                    console.log('🟢 CanaisDetails: Novo config', newConfig.generalConfig?.feedbackTemplate);
                    return newConfig;
                });
                break;
            case 'generalConfig.feedbackTemplateVariaveis':
                console.log('🟢 CanaisDetails: Atualizando feedbackTemplateVariaveis', value);
                setConfig((prevConfig) => {
                    const newConfig = {
                        ...prevConfig,
                        generalConfig: { ...(prevConfig.generalConfig || {}), feedbackTemplateVariaveis: value },
                    };
                    console.log('🟢 CanaisDetails: Novo config variáveis', newConfig.generalConfig?.feedbackTemplateVariaveis);
                    return newConfig;
                });
                break;
            case 'laisGo.status':
                setConfig({ ...config, laisGo: { ...(config.laisGo || {}), status: value } });
                break;
            case 'departamentConfig.allocate.status':
                // Se allocate.status for true, desabilita wallet.status
                const newWalletStatus = value === true ? false : config.departamentConfig?.wallet?.status;
                setConfig({
                    ...config,
                    departamentConfig: {
                        ...(config.departamentConfig || {}),
                        allocate: { ...(config.departamentConfig?.allocate || {}), status: value },
                        wallet: { ...(config.departamentConfig?.wallet || {}), status: newWalletStatus },
                    },
                });
                break;
            case 'departamentConfig.allocate.type':
                setConfig({
                    ...config,
                    departamentConfig: {
                        ...(config.departamentConfig || {}),
                        allocate: { ...(config.departamentConfig?.allocate || {}), type: value },
                    },
                });
                break;
            case 'departamentConfig.allocate.period':
                setConfig({
                    ...config,
                    departamentConfig: {
                        ...(config.departamentConfig || {}),
                        allocate: { ...(config.departamentConfig?.allocate || {}), period: value },
                    },
                });
                break;
            case 'departamentConfig.defaultSector':
                setConfig({ ...config, departamentConfig: { ...(config.departamentConfig || {}), defaultSector: value } });
                break;
            case 'departamentConfig.allocate.ignoreUsersOff':
                setConfig({
                    ...config,
                    departamentConfig: {
                        ...(config.departamentConfig || {}),
                        allocate: { ...(config.departamentConfig?.allocate || {}), ignoreUsersOff: value },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.operation':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), operation: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.numberMsgs':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), numberMsgs: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.status':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), status: value },
                        },
                    },
                });
                break;
            case 'ai.autoTranscribeAudio':
                setConfig({ ...config, ai: { ...(config.ai || {}), autoTranscribeAudio: value } });
                break;
            case 'ai.autoTranscribeImage':
                setConfig({ ...config, ai: { ...(config.ai || {}), autoTranscribeImage: value } });
                break;
            case 'departamentConfig.wallet.status':
                // Se wallet.status for true, desabilita allocate.status
                const newAllocateStatus = value === true ? false : config.departamentConfig?.allocate?.status;
                setConfig({
                    ...config,
                    departamentConfig: {
                        ...(config.departamentConfig || {}),
                        wallet: { ...(config.departamentConfig?.wallet || {}), status: value },
                        allocate: { ...(config.departamentConfig?.allocate || {}), status: newAllocateStatus },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.customPrompts':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), customPrompts: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.prompt_alerts':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), prompt_alerts: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.prompt_predictive':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), prompt_predictive: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.prompt_resume':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), prompt_resume: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.prompt_sentiment':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), prompt_sentiment: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.prompt_subject':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), prompt_subject: value },
                        },
                    },
                });
                break;
            case 'ai.modules.aiAnalysisChat.prompt_suggestion':
                setConfig({
                    ...config,
                    ai: {
                        ...config.ai,
                        modules: {
                            ...(config.ai.modules || {}),
                            aiAnalysisChat: { ...(config.ai.modules?.aiAnalysisChat || {}), prompt_suggestion: value },
                        },
                    },
                });
                break;
            case 'chatflow.chatflow_id':
                setConfig({ ...config, chatflow: { ...(config.chatflow || {}), chatflow_id: value } });
                break;
            case 'whatsapp_business_id':
                setConfig({
                    ...config,
                    meta: {
                        ...config.meta,
                        whatsappBusinness: { ...(config.meta?.whatsappBusinness || {}), fromNumberId: value },
                    },
                });
                break;
            case 'whatsapp_business_token':
                setConfig({
                    ...config,
                    meta: {
                        ...config.meta,
                        whatsappBusinness: { ...(config.meta?.whatsappBusinness || {}), accessToken: value },
                    },
                });
                break;
            case 'wabaId':
                setConfig({
                    ...config,
                    meta: { ...config.meta, whatsappBusinness: { ...(config.meta?.whatsappBusinness || {}), wabaId: value } },
                });
                break;
            case 'sla_tempo_aceite':
                setConfig({ ...config, sla_tempo_aceite: value ? Number(value) * 60 : '' });
                break;
            case 'aiSchedulePause.status':
                setConfig({
                    ...config,
                    aiSchedulePause: { ...(config.aiSchedulePause || {}), status: value },
                });
                break;
            case 'aiSchedulePause.action':
                setConfig({
                    ...config,
                    aiSchedulePause: { ...(config.aiSchedulePause || {}), action: value },
                });
                break;
            case 'aiSchedulePause.direciona_usuarios':
                setConfig({
                    ...config,
                    aiSchedulePause: { ...(config.aiSchedulePause || {}), direciona_usuarios: value },
                });
                break;
            case 'aiSchedulePause.direciona_setores':
                setConfig({
                    ...config,
                    aiSchedulePause: { ...(config.aiSchedulePause || {}), direciona_setores: value },
                });
                break;
            case 'aiSchedulePause.schedules':
                setConfig({
                    ...config,
                    aiSchedulePause: { ...(config.aiSchedulePause || {}), schedules: value },
                });
                break;
        }
    }

    async function handleOnChangeAutomCompleteChannel(e, newValue, name) {
        const mapping = newValue.map((item) => item._id);
        switch (name) {
            case 'directTargetUser':
                setConfig({
                    ...config,
                    direcionamento_direto: { ...config.direcionamento_direto, direciona_usuario: mapping },
                });
                break;
            case 'directTargetSector':
                setConfig({ ...config, direcionamento_direto: { ...config.direcionamento_direto, direciona_setor: mapping } });
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        getListUsers();
        getListSectors();
        getDetailsChannel();
    }, []);

    return (
        <div className="flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-3">
                        <Button
                            size="icon"
                            variant="outline"
                            className="w-9 h-9 rounded-full bg-white border-gray-200 shadow-sm"
                            onClick={() => {
                                navigate('/dashboard/configuracoes/canais');
                            }}
                        >
                            <Iconify icon="majesticons:arrow-left" className="text-gray-700" />
                        </Button>
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">{canal?.nome || 'Novo Canal'}</h1>
                    </div>
                    {/* Padding left to align with title text (approx icon width + gap) */}
                    <p className="text-sm text-gray-500 pl-12">Gerencie as configurações e integrações deste canal de atendimento.</p>
                </div>
                <ButtonLoading
                    loading={loading}
                    onClick={createChannel}
                    className="!h-auto flex items-center gap-2 px-6 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95 border-none"
                    variant="default" // forcing default variant to ensure no conflict with outline
                >
                    {isEdit ? 'Salvar Configurações' : 'Criar Canal'}
                </ButtonLoading>
            </div>

            <div className="flex flex-col gap-4">
                <CanaisConfig
                    cliente={cliente}
                    user={user}
                    listUsers={listUsers}
                    listSectors={listSectors}
                    isEdit={isEdit}
                    config={config}
                    canal={makeChannel}
                    onChange={(e, newValue) => handleOnChangeChannel(e, newValue)}
                    onChangeAutocomplete={(e, newValue, name) => handleOnChangeAutomCompleteChannel(e, newValue, name)}
                    changeAgent={(value) => {
                        setConfig({ ...config, dialogflow: { ...config.dialogflow, projectId: value } });
                    }}
                    onChangeChannel={(value) => {
                        if (value.target === 'channelType') {
                            setCanal({ ...canal, platform: value.value });
                        } else if (value.target === 'webhookType') {
                            setCanal({ ...canal, webhook_type: value.value });
                        }
                    }}
                />
            </div>
        </div>
    );
}